import React from 'react';
import { Alert, Box, List, ListItem, ListItemIcon, ListItemText, Typography } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

export interface GuideStep {
  id: string;
  title: string;
  instruction: string;
  complete: boolean;
  issue?: string;
}

interface StepGuideProps {
  steps: GuideStep[];
  hintMode: boolean;
}

const StepGuide: React.FC<StepGuideProps> = ({ steps, hintMode }) => (
  <Box component="section" aria-labelledby="titration-guide-title">
    <Typography id="titration-guide-title" variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
      Practical steps
    </Typography>
    <List dense disablePadding>
      {steps.map((step) => (
        <ListItem key={step.id} alignItems="flex-start" sx={{ px: 0, py: 0.5 }}>
          <ListItemIcon sx={{ minWidth: 30, pt: 0.3 }}>
            {step.issue ? <WarningAmberIcon color="warning" fontSize="small" /> : step.complete ? <CheckCircleOutlineIcon color="success" fontSize="small" /> : <RadioButtonUncheckedIcon color="disabled" fontSize="small" />}
          </ListItemIcon>
          <ListItemText
            primary={step.title}
            secondary={hintMode ? (step.issue || step.instruction) : step.complete ? 'Completed' : 'Not yet completed'}
            primaryTypographyProps={{ fontWeight: step.complete ? 600 : 500, variant: 'body2' }}
            secondaryTypographyProps={{ variant: 'caption', color: step.issue ? 'warning.dark' : 'text.secondary' }}
          />
        </ListItem>
      ))}
    </List>
    {steps.some((step) => step.issue) && (
      <Alert severity="warning" sx={{ mt: 1 }}>
        Correct the flagged procedure or safety issue before recording a result.
      </Alert>
    )}
  </Box>
);

export default StepGuide;